// extracted by mini-css-extract-plugin
export var actionButton = "_gg-t";
export var buttonContainer = "_gg-0";
export var buttonContainer2 = "_gg-1";
export var buttonSection = "_gg-2";
export var details = "_gg-3";
export var dropdownItem = "_gg-5";
export var dropdownItemsContainer = "_gg-4";
export var fileInput = "_gg-r";
export var headerButton = "_gg-6";
export var icon = "_gg-7";
export var input = "_gg-8";
export var macroListItem = "_gg-9";
export var mainContent = "_gg-a";
export var microText = "_gg-b";
export var modal = "_gg-w";
export var optionsButton = "_gg-c";
export var paperclip = "_gg-s";
export var pillContent = "_gg-d";
export var preview = "_gg-e";
export var preview2 = "_gg-f";
export var quillEditor = "_gg-q";
export var selectedMacro = "_gg-g";
export var sidebar = "_gg-h";
export var sidebarHeader = "_gg-j";
export var sidebarList = "_gg-i";
export var sidebarListItem = "_gg-k";
export var sidebarSearch = "_gg-l";
export var snoozeDurationWrapper = "_gg-v";
export var statusPillContainer = "_gg-m";
export var tagsContainer = "_gg-n";
export var unselectedMacro = "_gg-o";
export var variable = "_gg-u";
export var wrapper = "_gg-p";